import { blackListedNumbers } from "./consts"

export const valutaDisplay = (input:number): string =>
  Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
  }).format(input)

export const isNonBlacklistedPhone = (phone: string | undefined): boolean => {
  const blacklisted = blackListedNumbers.includes(phone || "")
  return !blacklisted
}
